import { makeSurfaceToken } from '@utils/css';

const linkSurface = makeSurfaceToken("--slider-link", {
  color: "255 255 255",
  background: "0 0 0 / 0.8"
});
const wrapper = "_b7nwxm8pka";
const imageCls = "_b7ni78p2aa";
const link = "_b7nl17hyh7q";

export { imageCls, link, linkSurface, wrapper };
import "./Slide.style.linaria.module.css";
//# sourceMappingURL=Slide.style.js.map
